export const placementAlternateMap = {
  top: "bottom",
  bottom: "top",
  left: "right",
  right: "left",
  "top-start": "top-end",
  "top-end": "top-start",
  "bottom-start": "bottom-end",
  "bottom-end": "bottom-start",
};